var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1417_1615)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1053 33.9474L17.7368 31.2632L7 36.6316V13.3684L17.7368 8L28.4737 13.3684L39.2105 8V21.421",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7368 8V31.2631",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4736 13.3682V23.2103",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4271 36.8477C40.178 36.0969 40.6895 35.1404 40.8968 34.099C41.104 33.0575 40.9978 31.9781 40.5915 30.997C40.1853 30.016 39.4972 29.1774 38.6143 28.5875C37.7314 27.9975 36.6934 27.6826 35.6316 27.6826C34.5698 27.6826 33.5318 27.9975 32.6489 28.5875C31.766 29.1774 31.078 30.016 30.6717 30.997C30.2654 31.9781 30.1592 33.0575 30.3665 34.099C30.5737 35.1404 31.0852 36.0969 31.8361 36.8477C32.5841 37.5974 33.8493 38.7177 35.6316 40.2101C37.5123 38.6174 38.7793 37.4972 39.4271 36.8477Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6316 33.0527V33.0706",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1417_1615",
    x: -17.4,
    y: -17.4,
    width: 82.8,
    height: 82.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1417_1615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1417_1615",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapToggleIcon);
export default __webpack_public_path__ + "static/media/map-toggle-icon.69241ded3079274f52e876e0481d0852.svg";
export { ForwardRef as ReactComponent };